import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { PagesService } from '../../services/pages.service';
import { CoursesEditComponent } from './courses-edit/courses-edit.component';
import { CourseService } from './service/course.service';

@Component({
	selector: 'app-courses',
	templateUrl: './courses.page.html',
	styleUrls: ['./courses.page.scss'],
})
export class CoursesPage implements OnInit {
	getCourseList$: Observable<any> = this.courseService.fetchCourseData();
	showHeaderFilter = true;

	currentPagePermission = 'courses';
	constructor(
		private router: Router,
		public popoverController: PopoverController,
		public modalController: ModalController,
		private courseService: CourseService,
		public pagesService: PagesService,
	) {
		//

		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app',
		);
	}

	ngOnInit() {
		this.courseService.loadCoursesApi().subscribe();
		this.courseService.loadCourseDataApi().subscribe();
	}
	isCanOpenBox = true;

	async editCourses(courses: any, ev: any) {
		ev.stopPropagation();
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: CoursesEditComponent,
				componentProps: {
					courses,
					isUpdate: true,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	async addCourses() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: CoursesEditComponent,
				componentProps: {
					isCreate: true,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
	deleteCourses(course: any, ev: any) {
		ev.stopPropagation();
	}

	viewInfo(id: any) {
		this.router.navigate([`app/courses/${id}/cohorts`]);
	}
}
